import { BaseTestResultItem } from "./BaseTestResultItem";
import { ITestingContext } from "./ITestingContext";
import { ITestResultItem } from "./ITestResultItem";
import { EventLog } from "../Event/EventLog";
import { DataUtilities } from "../DataUtilities";

export abstract class BaseTestResultData extends BaseTestResultItem implements ITestingContext {
    isShowResult: boolean = true;

    // we might need to break this up and store separate.
    items: ITestResultItem[] = [];

    logs: EventLog[] = [];

    addTestResultItem(item: ITestResultItem): void {
        this.items.push(item);
    }

    addLogItem(item: EventLog): void {
        this.logs.push(item);
    }

    addLogItems(items: EventLog[]): void {
        this.logs.push(...items);
    }

    getDuration(): string {
        if (this.endDate) {
            return DataUtilities.getElapsedTime(this.when, this.endDate);
        }
        if (this.logs.length === 0) return "";
        return DataUtilities.getElapsedTime(this.logs[0].when, this.logs[this.logs.length - 1].when);
    }

    findItem(itemId: string): ITestResultItem | undefined {
        if (itemId === this.itemId) return this;

        for (let item of this.items) {
            if (item.itemId === itemId) return item;

            if (item instanceof BaseTestResultData) {
                let subitem = item.findItem(itemId);

                if (subitem) return subitem;
            }
        }
    }
}
